import { render, staticRenderFns } from "./Estudianteqr.vue?vue&type=template&id=5851004f"
import script from "./Estudianteqr.vue?vue&type=script&lang=js"
export * from "./Estudianteqr.vue?vue&type=script&lang=js"
import style0 from "./Estudianteqr.vue?vue&type=style&index=0&id=5851004f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports